/* eslint-disable @typescript-eslint/naming-convention */
import { mapKeys } from 'lodash';
import { ISbComponentType } from 'storyblok-js-client';
import { StringService } from '../../services';
import { Default } from '../default';
import { AnyProps } from '../types';

interface RocheNextStepConditionBlok extends ISbComponentType<'roche-next-step-condition'> {
  field_name: string;
  field_value: string;
  next_step_id: string;
}

const RocheFormEmail = ({ blok, ...rest }: AnyProps): JSX.Element => Default({
  blok: {
    ...blok,
    component: 'roche-form',
    type: 'email',
  },
  ...rest,
});

/*
 * Filters the properties for the next step out of the Storyblok Component.
 * Renames the relevant properties.
 */
const mapRocheNextStepConditionBlokToProperty = (
  nextSteps: RocheNextStepConditionBlok[],
) => nextSteps.map((nextStep) => {
  const { fieldName, fieldValue, nextStepId } = mapKeys(nextStep,
    (_val, key) => StringService.snakeToCamel(key));
  return { fieldName, fieldValue, nextStepId };
});

const mapSlotted = (slotted) => slotted.forEach((formStep) => {
  // eslint-disable-next-line no-param-reassign
  formStep['next-steps'] = mapRocheNextStepConditionBlokToProperty(formStep.next_steps);
});

const RocheMultiStepForm = ({ blok, ...rest }: AnyProps): JSX.Element => Default({
  blok: {
    component: 'roche-multi-step-form',
    slotted: mapSlotted(blok.slotted),
    ...blok,
  },
  ...rest,
});

export const forms = {
  'roche-form-email': RocheFormEmail,
  'roche-multi-step-form': RocheMultiStepForm,
  'roche-form': Default,
};
